import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiMapPin, FiPhone, FiMail, FiClock, 
  FiFacebook, FiInstagram, FiYoutube, 
  FiHeart, FiShoppingBag, FiTool, FiInfo, 
  FiMail as FiMailIcon, FiHome, FiSend
} from 'react-icons/fi';
import { FaTelegramPlane } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'ទំព័រដើម', path: '/', icon: FiHome },
    { name: 'ផលិតផល', path: '/products', icon: FiShoppingBag },
    { name: 'អត្ថបទ', path: '/repairs', icon: FiTool },
    { name: 'អំពីយើង', path: '/about', icon: FiInfo },
    { name: 'ទំនាក់ទំនង', path: '/contact', icon: FiMailIcon }
  ];

  const services = [
    { name: 'លក់ផលិតផលញ៉ាំក្នុងស្រុក', icon: FiShoppingBag },
    { name: 'ផលិតផលស្រស់ៗ', icon: FiHeart },
    { name: 'គុណភាពខ្ពស់', icon: FiShoppingBag },
    { name: 'ធានាគុណភាព ១០០%', icon: FiHeart },
    { name: 'ដឹកជញ្ជូនលឿន', icon: FiSend }
  ];

  const socialLinks = [
    { icon: FiFacebook, url: 'https://web.facebook.com/GrandFatherSmile', label: 'Facebook', color: '#1877f2' },
    { icon: FiInstagram, url: 'https://instagram.com/grandfathersmile', label: 'Instagram', color: '#e4405f' },
    { icon: FaTelegramPlane, url: 'https://t.me/GrandFatherSmile', label: 'Telegram', color: '#0088cc' },
    { icon: FiYoutube, url: '#', label: 'YouTube', color: '#ff0000' }
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">អំពី GrandFatherSmile</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              GrandFatherSmile គឺជាវេបសាយសម្រាប់លក់ផលិតផលរបស់ញ៉ាំក្នុងស្រុក 
              បង្កើតឡើងដោយកូនខ្មែរ ផ្តល់ជូននូវផលិតផលស្រស់ មានគុណភាព 
              ជាមួយនឹងការធានាផលិតផល និងសេវាកម្មក្រោយពេលលក់ដ៏ល្អប្រសើរ។
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 bg-gray-800 text-gray-400 hover:bg-red-600 hover:text-white transition-colors"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">តំណរហ័ស</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => {
                const Icon = link.icon;
                return (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="flex items-center gap-2 text-gray-400 hover:text-red-600 transition-colors text-sm"
                    >
                      <Icon size={14} />
                      <span>{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">សេវាកម្មរបស់យើង</h3>
            <ul className="space-y-2">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <li key={index} className="flex items-center gap-2 text-gray-400 text-sm">
                    <Icon size={14} className="text-red-600" />
                    <span>{service.name}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Contact Info + Developer Credit */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">ទំនាក់ទំនង</h3>
            <div className="space-y-3">
              <div className="flex gap-3">
                <FiMapPin className="text-red-600 mt-1 flex-shrink-0" size={16} />
                <p className="text-gray-400 text-sm">
                  ភ្នំពេញ, កម្ពុជា
                </p>
              </div>
              <div className="flex gap-3">
                <FiPhone className="text-red-600 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-gray-400 text-sm">+855 10 612636</p>
                </div>
              </div>
              <div className="flex gap-3">
                <FiMail className="text-red-600 mt-1 flex-shrink-0" size={16} />
                <p className="text-gray-400 text-sm">grandfathersmile@gmail.com</p>
              </div>
              <div className="flex gap-3">
                <FiClock className="text-red-600 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-gray-400 text-sm">
                    <span className="font-medium text-white">ចន្ទ - អាទិត្យ:</span> ៨:០០ - ២១:០០
                  </p>
                  <p className="text-green-500 text-xs mt-1 flex items-center gap-1">
                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full"></span>
                    បើករាល់ថ្ងៃ
                  </p>
                </div>
              </div>
            </div>
            
            {/* Developer Credit Section - Right Sidebar */}
            <div className="mt-6 pt-4 border-t border-gray-800">
              <div className="bg-gray-800/50 rounded-lg p-3">
                <p className="text-gray-400 text-xs mb-2">បង្កើតដោយ</p>
                <a 
                  href="https://t.me/thymuoyhak" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-300 hover:text-red-500 transition-colors group"
                >
                  <span className="font-medium text-sm group-hover:underline">ធី មួយហាក់ (Thy Muoyhak)</span>
                  <FaTelegramPlane size={14} className="text-[#0088cc]" />
                </a>
                <p className="text-gray-500 text-xs mt-2 flex items-center gap-1">
                  <FiHeart size={10} className="text-red-600" />
                  Full-Stack Developer
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div>
              <h3 className="text-white font-bold text-lg mb-2">ទទួលបានព័ត៌មានថ្មីៗ</h3>
              <p className="text-gray-400 text-sm">
                ចុះឈ្មោះទទួលបានព័ត៌មានថ្មីៗ និងការផ្តល់ជូនពិសេសពី GrandFatherSmile
              </p>
            </div>
            <div>
              <form className="flex" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  placeholder="អ៊ីមែលរបស់អ្នក..."
                  className="flex-1 px-4 py-2 border border-gray-700 bg-gray-800 text-gray-300 text-sm focus:outline-none focus:border-red-600"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors"
                >
                  ចុះឈ្មោះ
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Opening Hours Banner */}
        <div className="mt-6 pt-4 border-t border-gray-800">
          <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-lg p-3 text-center">
            <div className="flex items-center justify-center gap-2 flex-wrap">
              <FiClock className="text-white" size={18} />
              <span className="text-white font-medium">ម៉ោងបើកដំណើរការ:</span>
              <span className="text-white font-bold">ចន្ទ - អាទិត្យ</span>
              <span className="text-white">៨:០០ ព្រឹក - ៩:០០ យប់</span>
              <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full ml-2">
                បើករាល់ថ្ងៃ
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-xs">
            © {currentYear} GrandFatherSmile. រក្សាសិទ្ធិគ្រប់យ៉ាង។
          </p>
          <p className="text-gray-600 text-xs mt-1 flex items-center justify-center gap-1">
            បង្កើតឡើងដោយកូនខ្មែរ <FiHeart className="text-red-600 inline" size={12} /> សម្រាប់ផលិតផលញ៉ាំក្នុងស្រុក
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;